import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.number.constructor";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.find";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bgContain from "./components/bgContain";
import packageTableMixins from "@/mixins/packageTableMixins.js";
import { get_website_data } from "@/api/chuku";
import { ChartPieCircle, ChartLine, ChartLineStackMul, ChartMap, ChartBarMulHorizon, ChartPie } from "_c/charts";
import { get_index_data, merchant_list, get_alarm_box } from "@/api/jingxiaoshang";
import { getMonthToCurrent } from "@/libs/util";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmCityList from "vue-baidu-map/components/controls/CityList.vue";
import BmGeolocation from "vue-baidu-map/components/controls/Geolocation.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
import BmLabel from "vue-baidu-map/components/overlays/Label.vue";
import BmLocalSearch from "vue-baidu-map/components/search/LocalSearch.vue";
import BmInfoWindow from "vue-baidu-map/components/overlays/InfoWindow";
import MyOverlay from "./components/myMapOverlay.vue";
import sjhz from "@/assets/sxwt.png";
import cfdqs from "@/assets/jhqs.png";
import sbgj from "@/assets/gjxx.png";
import sjhz1 from "@/assets/sxwt1.png";
import cfdqs1 from "@/assets/jhqs1.png";
import sbgj1 from "@/assets/gjxx1.png";
import zrl from "@/assets/zrl.png";
import echarts from "echarts";
import { commonReq } from "@/api/common.js";
import { getMenuByRouterRole } from "@/libs/util";
import router from "@/router";
import routersArr from "@/router/routers"; //本地路由

import menuList from "@/router/module/menu.js"; //本地路由

export default {
  mixins: [packageTableMixins],
  data: function data() {
    var _this = this,
        _ref2;

    return _ref2 = {
      routerData: null,
      titleName: null,
      setIner: null,
      alertJihuoList: [],
      alerjihuotDataList: [],
      alertLineList: {},
      onlineList: [],
      deviceAlarm: [],
      datetype1: "day",
      datetype2: "day",
      datetypeyList: [{
        value: "day",
        label: "天"
      }, {
        value: "month",
        label: "月"
      }, {
        value: "year",
        label: "年"
      }],
      sjhz: sjhz,
      cfdqs: cfdqs,
      sbgj: sbgj,
      sjhz1: sjhz1,
      cfdqs1: cfdqs1,
      sbgj1: sbgj1,
      zrl: zrl,
      tableHeight: null,
      columns11: [// {
      //   title: "序号",
      //   key: "xuhao",
      // },
      {
        title: "描述",
        key: "desc"
      }, {
        title: "值",
        key: "value"
      }],
      data11: [{
        xuhao: "01",
        desc: this.$t("dailishangzongshu"),
        value: 0
      }, // {
      //   xuhao: '02',
      //   desc: '用户总数',
      //   value: 0,
      // },
      {
        xuhao: "03",
        desc: this.$t("shebeizongshu"),
        value: 0
      }, {
        xuhao: "04",
        desc: this.$t("zaixianshebeishu"),
        value: 0
      }],
      devicePieData: [],
      //
      merchant_total: 0,
      user_total: 0,
      did_count: 0,
      did_online_count: 0,
      //  handleClick:"",
      sensor_count: 100,
      setInt: null,
      loop: true,
      muted: true,
      playStatus: false,
      bgmusic: "",
      unitList: {
        1: "PPM",
        2: "%LEL",
        3: "kppm",
        4: "ppb",
        5: "V/V%",
        6: "mg/m3",
        7: "umol/mol",
        8: "%VOL",
        9: "ug/m3",
        10: "%RH",
        11: "PPHM",
        12: "mg/L",
        13: "g/m3",
        14: "L/M",
        15: "KPa",
        16: "m",
        17: "km",
        18: "cm",
        19: "mm"
      },
      sensorTypeList: {
        1: "CO",
        2: "甲烷",
        3: "氢气",
        4: "可燃气",
        5: "硫化氢",
        6: "氧气"
      },
      sensorList: [],
      //传感器列表
      spinShowLeft: false,
      spinShowRight: false,
      currMerchan: null,
      active: false,
      merchanData: [],
      myGeo: null,
      searchValue: null,
      location: null,
      keyword: null,
      center: {
        lng: 116.404,
        lat: 39.915
      },
      zoom: 3,
      BMap: null,
      map: null,
      position: {
        lng: 0,
        lat: 0
      },
      spinShow: false,
      currDate: null,
      currDate1: null,
      alertRakingLegend: [],
      alertRakingXAxis: [],
      //
      alertRakingDataList: [],
      //排行数值列表
      pHeight: 0,
      shoplist: [],
      device_alarm_recent: [],
      device_total: 0,
      alarm_wait_handle_num: 0,
      userActviexAxis: [],
      alertTotalList: [],
      alertTimeList: [],
      alertDataList: [],
      alertTotalList2: [],
      alertTimeList2: [],
      alertDataList2: [],
      nodeListData: [],
      selectBtn7: true,
      selectBtn30: false,
      middleData: [{
        value: 0,
        label: "设备总数"
      }, {
        value: 0,
        label: "设备在线数量"
      }, {
        value: 0,
        label: "设备离线数量"
      }, {
        value: "0%",
        label: "在线率"
      }],
      timeout: null
    }, _defineProperty(_ref2, "zoom", 5), _defineProperty(_ref2, "currTime", null), _defineProperty(_ref2, "projectDetails", {
      address: null,
      alarm_count: null,
      building_name: null,
      count: null,
      customer_user: null,
      id: null,
      lat: null,
      lng: null,
      maintain_user: [],
      project_code: "",
      project_name: "",
      tel: ""
    }), _defineProperty(_ref2, "showDetails", false), _defineProperty(_ref2, "geoCoordMap", {}), _defineProperty(_ref2, "columnShop", [{
      title: "商户",
      key: "shop_name",
      align: "center",
      render: function render(h, _ref) {
        var row = _ref.row;
        return h("div", {
          on: {
            click: function click() {
              _this.$router.push({
                name: "homeMerchant",
                params: {
                  code: row.merchant_code
                }
              });
            }
          }
        }, row.shop_name);
      }
    }]), _defineProperty(_ref2, "columns1", [{
      title: this.$t("deviceId"),
      key: "device_id",
      align: "left"
    }, {
      title: this.$t("告警内容"),
      key: "data_type_name",
      align: "center",
      maxWidth: 85
    }, {
      title: this.$t("告警时间"),
      key: "alarm_time",
      align: "center"
    }]), _defineProperty(_ref2, "columnsLeft", [{
      title: this.$t("deviceId"),
      key: "did",
      align: "left"
    }, {
      title: this.$t("latestLaunchTime"),
      key: "status_time",
      align: "center"
    }, {
      title: this.$t("activationTime"),
      key: "jihuo_time",
      align: "center"
    }]), _defineProperty(_ref2, "data1", []), _defineProperty(_ref2, "mapData", []), _defineProperty(_ref2, "deviceTotal", 0), _defineProperty(_ref2, "personData", [{
      value: 0,
      name: "管理员"
    }, {
      value: 0,
      name: "普通用户"
    }, {
      value: 0,
      name: "平台维护"
    }, {
      value: 0,
      name: "超级管理员"
    }]), _defineProperty(_ref2, "deviceData", [{
      value: 0,
      name: "在线设备"
    }, {
      value: 0,
      name: "离线设备"
    }, {
      value: 0,
      name: "故障设备"
    }]), _defineProperty(_ref2, "alertTotile", 0), _defineProperty(_ref2, "alertData", []), _defineProperty(_ref2, "deviceYearIncrease", []), _defineProperty(_ref2, "userActvieData", []), _defineProperty(_ref2, "alertListData", []), _defineProperty(_ref2, "reqBase", {
      page: 1,
      page_size: 10
    }), _defineProperty(_ref2, "projectList", []), _defineProperty(_ref2, "projectTotal", 0), _defineProperty(_ref2, "height", 200), _defineProperty(_ref2, "listLoading", false), _defineProperty(_ref2, "tableLeftHeheight", null), _defineProperty(_ref2, "local", localStorage.getItem("local")), _ref2;
  },
  components: {
    ChartPie: ChartPie,
    bgContain: bgContain,
    ChartPieCircle: ChartPieCircle,
    ChartLine: ChartLine,
    ChartMap: ChartMap,
    ChartLineStackMul: ChartLineStackMul,
    ChartBarMulHorizon: ChartBarMulHorizon,
    BaiduMap: BaiduMap,
    BmGeolocation: BmGeolocation,
    BmCityList: BmCityList,
    BmMarker: BmMarker,
    BmLabel: BmLabel,
    BmLocalSearch: BmLocalSearch,
    BmInfoWindow: BmInfoWindow,
    MyOverlay: MyOverlay
  },
  computed: {
    projectCode: function projectCode() {
      return this.$store.state.user.projectCode;
    },
    userInfoStore: function userInfoStore() {
      var data = this.$store.state.user.userInfo;
      return data;
    }
  },
  methods: {
    /**
     * 右侧告警
     */
    getAlertRight: function getAlertRight() {
      var _this2 = this;

      commonReq("/index.php/admin/alarm/new_alarm_list", {
        page: 1,
        page_size: 10
      }).then(function (res) {
        _this2.deviceAlarm.splice(0);

        console.log("new_alarm_list", res);

        if (res.result === 0) {
          _this2.deviceAlarm = res.body.list || [];
        }
      });
    },

    /**
     * 大屏左下方近7日激活(仅顶级账号可见)
     */
    getAdminAction: function getAdminAction() {
      var _this3 = this;

      // this.$set(this,'alertLineList',{})
      commonReq("/index.php/admin/datatongji/home_jihuo_info", {}).then(function (res) {
        _this3.alertJihuoList.splice(0);

        _this3.alerjihuotDataList.splice(0);

        if (res.result === 0) {
          var data = res.body;
          var tem = [];

          for (var i in data) {
            var list = data[i];
            tem.push(list.count);

            _this3.alertJihuoList.push(list.date);
          }

          _this3.alerjihuotDataList.push({
            name: _this3.$t("jihuoqushi"),
            data: tem,
            type: "line",
            // stack: 'Total',
            smooth: true,
            lineStyle: {
              width: 0.1
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "rgba(45, 190, 255, 0.30)"
              }, {
                offset: 1,
                color: "rgba(45, 190, 255, 0)"
              }])
            },
            emphasis: {
              focus: "series"
            }
          }); // this.$set(this,'alertLineList',obj)

        }
      });
    },

    /**
     * 大屏左上角在线数据
     */
    getOnlineInfo: function getOnlineInfo() {
      var _this4 = this;

      commonReq("/index.php/admin/datatongji/home_online_info", {}).then(function (res) {
        _this4.onlineList.splice(0);

        if (res.result === 0) {
          _this4.onlineList = res.body || [];
        }
      });
    },

    /**
     * 获取顶部数据
     */
    getTopData: function getTopData() {
      commonReq("/index.php/admin/datatongji/home_tongji", {}).then(function (res) {});
    },
    selectchange: function selectchange(value, datetype) {
      console.log(value, datetype);
      this.getHomeData(); // console.log(this.datetype1)
      // console.log(value)
    },
    rowClassName: function rowClassName(row, index) {
      if (index % 2) {
        return "demo-table-info-row";
      } else {
        return "demo-table-error-row";
      }

      return "";
    },
    backConsole: function backConsole() {
      //window.location.href='/jingxiaoshang'
      var routeData = this.$router.resolve({
        path: "/jingxiaoshang",
        query: {
          home: 1
        }
      });
      window.open(routeData.href, "_self");
    },
    downloadClick: function downloadClick(name) {
      var _this5 = this;

      if (name === "console") {
        var item = this.routerData.find(function (item) {
          return item.menu_name == "设备管理";
        });

        if (item) {
          console.log(item.children_menu[0].route); // 找到时打印1

          var routesMenu = sessionStorage.getItem("routesMenu");
          var arr = JSON.parse(routesMenu);
          var tiaozhuan = item.children_menu[0].route;
          var routeData = this.$router.push({
            path: tiaozhuan,
            query: {
              home: 1
            }
          });
        } else {
          if (this.routerData[this.routerData.length - 1].children_menu.length > 0) {
            var _routesMenu = sessionStorage.getItem("routesMenu");

            var _arr = JSON.parse(_routesMenu);

            var _tiaozhuan = this.routerData[this.routerData.length - 1].children_menu[0].route;

            var _routeData = this.$router.push({
              path: _tiaozhuan,
              query: {
                home: 1
              }
            });
          } else {
            var _routesMenu2 = sessionStorage.getItem("routesMenu");

            var _arr2 = JSON.parse(_routesMenu2);

            var _tiaozhuan2 = this.routerData[this.routerData.length - 1].route;

            var _routeData2 = this.$router.push({
              path: _tiaozhuan2,
              query: {
                home: 1
              }
            });
          }
        } // window.open(routeData.href, "_self");
        //this.$router.push("/jingxiaoshang")

      } else if (name === "logout") {
        this.$store.dispatch("handleLogOut").then(function (res) {
          if (res.result === 0) {
            _this5.$router.push({
              name: "login"
            });
          }
        });
      }
    },
    handleClick: function handleClick() {
      window.location.href = this.pic_url;
    },
    refreshAlert: function refreshAlert() {
      var _this6 = this;

      this.spinAlertShow = true;
      this.device_alarm_recent.splice(0);
      get_index_data({
        data_type: 1
      }).then(function (res) {
        _this6.spinAlertShow = false;

        if (res.result === 0) {
          if (res.body.device_alarm_recent) {
            _this6.device_alarm_recent = res.body.device_alarm_recent || [];
          }
        }
      });
    },
    infoWindowClose: function infoWindowClose() {},
    infoWindowOpen: function infoWindowOpen() {},
    viewDes: function viewDes(item) {
      this.$router.push({
        name: "homeMerchant",
        params: {
          code: item.merchant_code
        }
      });
    },

    /**
     * 获取商户列表
     */
    getMerchantList: function getMerchantList() {
      var _this7 = this;

      // this.$set(this,'currMerchan',{...this.shoplist[0],show:true,offset:new this.BMap.Size(0,-22)})
      this.merchanData.splice(0);
      merchant_list({
        page: 1,
        type: 1,
        page_size: 1000
      }).then(function (res) {
        if (res.result === 0) {
          _this7.merchanData = res.body.list || [];

          if (_this7.merchanData && _this7.merchanData.length > 0) {
            _this7.$set(_this7, "currMerchan", _objectSpread({}, _this7.merchanData[0], {
              show: true,
              offset: new _this7.BMap.Size(0, -22)
            }));

            _this7.$set(_this7, "center", {
              lng: _this7.merchanData[0].lng,
              lat: _this7.merchanData[0].lat
            });
          }
        }
      });
    },
    clickMarker: function clickMarker(event, item) {
      this.$set(this, "currMerchan", _objectSpread({}, item, {
        show: true,
        offset: new this.BMap.Size(0, -22)
      }));
      console.log(event, item);
    },
    handler: function handler(_ref3) {
      var BMap = _ref3.BMap,
          map = _ref3.map;
      map.setMapStyleV2({
        styleId: "df02ec8c543c14e37c450baeb5d3457f"
      }); // this.zoom=12;
      // const _this = this
      // // 获取逆解析方法实例
      // this.myGeo = new BMap.Geocoder()
      // // 获取自动定位方法
      // const geolocation = new BMap.Geolocation()
      //   geolocation.getCurrentPosition(function (r) {
      //     if(r){
      //       _this.center = { lng: 103, lat: 30 }
      //       _this.$set(_this.center,'lng',103)
      //       _this.$set(_this.center,'lat',30)
      //       _this.initLocation = true
      //     }
      //   },{enableHighAccuracy:true})
      // _this.BMap = BMap
      // _this.map=map
    },

    /**
     * 地图点击事件
     */
    mapClick: function mapClick(_ref4) {
      var type = _ref4.type,
          target = _ref4.target,
          point = _ref4.point,
          pixel = _ref4.pixel,
          overlay = _ref4.overlay;
      var allOverlay = this.map.getOverlays();

      for (var i in allOverlay) {
        var list = allOverlay[i];

        if (list.formStat) {
          debugger;
          this.map.removeOverlay(list);
        }
      }

      console.log({
        type: type,
        target: target,
        point: point,
        pixel: pixel,
        overlay: overlay
      });
      this.$set(this, "position", point);
      console.log(this.position); // this.getLocationAddr(this.position)
      // this.getLatLng(point)
    },
    goAlertDes: function goAlertDes() {
      this.$router.push({
        name: "alermDes"
      });
    },
    changeCurrDate: function changeCurrDate(val) {
      this.currDate = val;
      this.getHomeData1(this.currDate, 2);
    },
    changeCurrDate1: function changeCurrDate1(val) {
      this.currDate1 = val;
      this.getHomeData2(this.currDate1, 1);
    },
    selectData: function selectData(value) {
      if (value === 7) {
        this.selectBtn7 = true;
        this.selectBtn30 = false;
      } else if (value === 30) {
        this.selectBtn7 = false;
        this.selectBtn30 = true;
      }

      this.getNodeUserActive(value);
    },
    close: function close() {
      this.showDetails = false;
    },
    clickProject: function clickProject(params) {
      var index = params.dataIndex;
      this.onRowClick(this.mapData[index], index, 1);
    },

    /**
     * 设备统计
     */
    getDeviceInfo: function getDeviceInfo() {
      var _this8 = this;

      get_device_info().then(function (res) {
        if (res.result === 0) {
          var data = res.body;

          _this8.$set(_this8.deviceData[0], "value", data.did_online);

          _this8.$set(_this8.deviceData[1], "value", data.did_offline);

          _this8.$set(_this8.deviceData[2], "value", data.did_fault);

          _this8.deviceTotal = data.did_total;
        }
      });
    },

    /**
     * 近一年的新增设备统计
     */
    getDeviceYearIncrease: function getDeviceYearIncrease() {
      var _this9 = this;

      this.deviceYearIncrease.splice(0);
      device_year_increase().then(function (res) {
        if (res.result === 0) {
          var list = res.body || [];

          for (var i in list) {
            _this9.deviceYearIncrease.push({
              value: list[i].num,
              name: list[i].str
            });
          }
        }
      });
    },

    /**
     * 获取未处理的告警
     */
    getUnAlertList: function getUnAlertList() {
      var _this10 = this;

      this.$Notice.destroy();
      this.alertListData.splice(0); ///this.listLoading=true;

      this.listLoading = false;
      alarm_list({
        page: 1,
        page_size: 30,
        status: 1
      }).then(function (res) {
        _this10.listLoading = false;

        if (res.result === 0) {
          var total = res.body.total;

          if (total > 0) {
            _this10.$Notice.warning({
              duration: 0,
              render: function render(h) {
                return h("div", {
                  style: {
                    cursor: "pointer",
                    display: "flex",
                    lineHeight: "80px",
                    "align-content": "center",
                    color: "#fff"
                  },
                  on: {
                    click: function click() {
                      _this10.$router.push({
                        name: "policeList",
                        query: {
                          status: 1
                        }
                      });

                      _this10.$Notice.destroy();
                    }
                  }
                }, "您还有" + total + "条报警信息未处理，请及时处理");
              }
            });
          }
        }
      });
    },

    /**
     * 获取告警记录
     */
    getAlertList: function getAlertList() {
      var _this11 = this;

      this.$Notice.destroy();
      this.alertListData.splice(0); ///this.listLoading=true;

      this.listLoading = false;
      alarm_list({
        page: 1,
        page_size: 30
      }).then(function (res) {
        _this11.listLoading = false;

        if (res.result === 0) {
          _this11.alertListData = res.body.list;
          var total = res.body.total;
        }
      });
    },
    deelData: function deelData(arr) {
      for (var i in arr) {
        var list = arr[i];

        if (list && list.project_list && list.project_list.length > 0) {
          list.children = list.project_list;
          list._showChildren = true;
          this.deelData(list.project_list);
        }
      }
    },

    /**
     * 获取项目及设备统计
     */
    getProjectList: function getProjectList() {
      var _this12 = this;

      this.projectList.splice(0);
      this.mapData.splice(0);
      indexProject_list(_objectSpread({}, this.reqBase, {
        page_size: -1
      })).then(function (res) {
        if (res.result === 0) {
          var data = res.body.list;
          _this12.projectTotal = res.body.total;

          _this12.deelData(data);

          console.log(data);

          for (var i in data) {
            var list = data[i];
            var count = 0;

            _this12.deelData(list);

            for (var j in list.project_list) {
              var item = list.project_list[j];
              var key = item.project_name;
              var value = item.count;
              count += item.count;

              if (item.lng) {
                _this12.mapData.push(_objectSpread({
                  value: value,
                  name: key
                }, item));

                _this12.geoCoordMap[key] = [Number(item.lng), Number(item.lat)]; // console.log(this.mapData)
                // console.log(this.geoCoordMap)
              }
            }

            _this12.projectList.push(_objectSpread({
              count: count,
              project_name: list.company_name
            }, list));
          }
        }
      });
    },
    pageOnchange: function pageOnchange() {},
    getCurrTime: function getCurrTime() {
      var dt = new Date();
      var y = dt.getFullYear();
      var mt = dt.getMonth() + 1;
      var day = dt.getDate();
      var h = dt.getHours(); //获取时

      var m = dt.getMinutes(); //获取分

      var s = dt.getSeconds(); //获取秒

      this.currTime = y + "年" + mt + "月" + day + "日-" + h + "时" + m + "分" + s + "秒";
    },
    alertClick: function alertClick(row) {
      this.$router.push({
        name: "policeList",
        query: {
          id: row.id
        }
      });
    },

    /**
     * 点击行数时
     */
    onRowClick: function onRowClick(row, index, type) {
      debugger;

      if (type === undefined) {
        if (row.lat) {
          this.projectDetails.maintain_user.splice(0);
          Object.assign(this.projectDetails, row);
          this.showDetails = true;
          this.center = [Number(row.lng), Number(row.lat)];
          this.zoom = 12;
        } else {
          this.$Message.error(row.project_name + "未在地图上标注");
        }
      } else {
        this.projectDetails.maintain_user.splice(0);
        Object.assign(this.projectDetails, row);
        this.showDetails = true;
        this.center = [Number(row.lng), Number(row.lat)];
        this.zoom = 12;
      }
    },
    onResize: function onResize() {
      this.tableHeight = this.$refs.coltopArea.clientHeight - 50;
      this.tableLeftHeheight = this.$refs.coltopAreaLeft.clientHeight - 50;
      console.log("bb", this.tableHeight); // let tableH=document.getElementById('tableWrapper')
      // if(tableH && tableH.offsetHeight){
      //   this.$set(this, 'height', tableH.offsetHeight - 55)
      //   //this.$set(this,'tableHeight',tableH.offsetHeight-55)
      //   this.height = tableH.offsetHeight - 55
      //   this.tableHeight = tableH.offsetHeight - 55
      //   console.log("bb",tableH.offsetHeight-55)
      // }
      // console.log(this.height)
    },

    /**
     * 中部设备地图
     */
    getNodeDeviceAll: function getNodeDeviceAll() {
      var _this13 = this;

      this.nodeListData.splice(0);
      node_device_all({
        project_code: this.projectCode
      }).then(function (res) {
        if (res.result === 0) {
          var data = res.body;

          _this13.$set(_this13.middleData[0], "value", data.device_total);

          _this13.$set(_this13.middleData[1], "value", data.device_online);

          _this13.$set(_this13.middleData[2], "value", data.device_offline);

          _this13.$set(_this13.middleData[3], "value", data.device_online_percentage);

          _this13.nodeListData = data.list || [];
        }
      });
    },

    /**
     * 右边顶部角色统计
     */
    getNodeUserAll: function getNodeUserAll() {
      var _this14 = this;

      this.personData.splice(0);
      node_user_all({
        project_code: this.projectCode
      }).then(function (res) {
        if (res.result === 0) {
          var total = 0;
          var data = res.body.node_groups;

          for (var i in data) {
            var list = data[i];

            _this14.personData.push({
              value: list.count,
              name: list.group_name
            });

            total += list.count;
          }

          _this14.deviceTotal = total;
        }
      });
    },

    /**
     * 用户活跃统计
     */
    getNodeUserActive: function getNodeUserActive(day_num) {
      var _this15 = this;

      this.userActvieData.splice(0);
      this.userActviexAxis.splice(0);
      node_user_active({
        project_code: this.projectCode,
        day_num: day_num
      }).then(function (res) {
        if (res.result === 0) {
          var data = res.body.active;

          for (var i in data.data) {
            var list = data.data[i];

            _this15.userActviexAxis.push(list.x_axis);

            _this15.userActvieData.push(list.total);
          }
        }
      });
    },

    /**
     * 左侧顶部在线率
     */
    getNodeDeviceOnline: function getNodeDeviceOnline() {
      var _this16 = this;

      this.data1.splice(0);
      node_device_online({
        project_code: this.projectCode
      }).then(function (res) {
        if (res.result === 0) {
          _this16.data1 = res.body;
        }
      });
    },
    getHomeData: function getHomeData(month_time, data_type) {
      var _this17 = this;

      ///this.spinShow=true
      this.spinShow = false;

      if (data_type === 1) {
        this.alertRakingDataList.splice(0);
        this.alertRakingLegend.splice(0);
        this.alertRakingXAxis.splice(0);
      } else if (data_type === 2) {
        this.alertDataList.splice(0);
      } else {
        this.alertDataList.splice(0);
        this.alertRakingXAxis.splice(0);
        this.alertRakingDataList.splice(0);
        this.alertRakingLegend.splice(0);
      }

      this.alertTimeList.splice(0);
      this.alertTimeList2.splice(0);
      get_index_data({
        datetype1: this.datetype1,
        datetype2: this.datetype2
      }).then(function (res) {
        _this17.spinShow = false;

        if (res.result === 0) {
          if (res.body.merchant_total) {
            _this17.merchant_total = res.body.merchant_total;
            _this17.data11[0].value = res.body.merchant_total;
          } // if (res.body.user_total) {
          //   this.user_total = res.body.user_total
          //   this.data11[1].value = res.body.user_total
          // }


          if (res.body.did_count) {
            _this17.did_count = res.body.did_count || [];
            _this17.data11[1].value = res.body.did_count;
          }

          if (res.body.did_online_count) {
            _this17.did_online_count = res.body.did_online_count || [];
            _this17.data11[2].value = res.body.did_online_count;
          }

          if (res.body.alarm_list) {
            _this17.device_alarm_recent = res.body.alarm_list.list || [];
          }

          console.log("aaaaa", res.body.alarm_list.list); // this.devicePieData.push(
          //   {
          //     value: res.body.pie_chart.did_online_count,
          //     name: "在线",
          //   }
          // );
          // this.devicePieData.push(
          //   {
          //     value: res.body.pie_chart.did_offline_count,
          //     name: "离线",
          //   }
          // );
          // this.devicePieData.push(
          //   {
          //     value: res.body.pie_chart.did_alarm_count,
          //     name: "告警",
          //   }
          // );

          console.log("aaa", res.body.qushi); //日告警数量分析

          if (res.body.qushi) {
            var tem = [];

            for (var i in res.body.qushi.zongrongliang) {
              var list = res.body.qushi.zongrongliang[i];
              tem.push(list.total);

              _this17.alertTimeList.push(list.x_axis);

              _this17.alertDataList.push({
                name: "总容量",
                data: tem,
                type: "line",
                // stack: 'Total',
                smooth: true,
                lineStyle: {
                  width: 0.1
                } // showSymbol: false,
                // areaStyle: {
                //   opacity: 0.8,
                //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                //     {
                //       offset: 0,
                //       color: 'rgba(45, 190, 255, 0.30)'
                //     },
                //     {
                //       offset: 1,
                //       color: 'rgba(45, 190, 255, 0)'
                //     }
                //   ])
                // },
                // emphasis: {
                //   focus: 'series'
                // },

              });
            }

            var tem2 = [];

            for (var _i in res.body.qushi.chongdian) {
              var _list = res.body.qushi.chongdian[_i];
              tem2.push(_list.total);

              _this17.alertTimeList2.push(_list.x_axis);

              _this17.alertDataList2.push({
                name: "充电",
                data: tem2,
                type: "line",
                lineStyle: {
                  width: 0.1
                },
                smooth: true // stack: 'Total',
                // smooth: true,
                // lineStyle: {
                //   width: 0
                // },
                // showSymbol: false,
                // areaStyle: {
                //   opacity: 0.8,
                //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                //     {
                //       offset: 0,
                //       color: 'rgba(254, 72, 61, 0.30)'
                //     },
                //     {
                //       offset: 1,
                //       color: 'rgba(254, 72, 61, 0)'
                //     }
                //   ])
                // },
                // emphasis: {
                //   focus: 'series'
                // },

              });
            } //this.alertTimeList2.splice()
            // this.alertDataList2.splice()


            var tem3 = [];

            for (var _i2 in res.body.qushi.fangdian) {
              var _list2 = res.body.qushi.fangdian[_i2];
              tem3.push(_list2.total); // this.alertTimeList2.push(list.x_axis)

              _this17.alertDataList2.push({
                name: "放电",
                data: tem3,
                type: "line",
                lineStyle: {
                  width: 0.1
                },
                smooth: true,
                // stack: 'Total',
                // smooth: true,
                // lineStyle: {
                //   width: 0
                // },
                // showSymbol: false,
                // areaStyle: {
                //   opacity: 0.8,
                //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                //     {
                //       offset: 0,
                //       color: 'rgba(8, 247, 161, 0.30)'
                //     },
                //     {
                //       offset: 1,
                //       color: 'rgba(8, 247, 161, 0)'
                //     }
                //   ])
                // },
                emphasis: {
                  focus: "series"
                }
              });
            } //地图数据
            //alert(123)
            //console.log( this.alertDataList)

          } //告警排行
          // if(res.body.alarm_phb){
          //   let alarm_num_list=[]
          //   for(let i in res.body.alarm_phb){
          //     let listAlerm=res.body.alarm_phb[i]
          //     this.alertRakingXAxis.push(listAlerm.shop_name)
          //     this.alertRakingLegend.push(listAlerm.shop_name)
          //     alarm_num_list.push(listAlerm.count1)
          //   }
          //   this.alertRakingDataList.push({
          //     name:'告警排行分析',
          //     data:alarm_num_list,
          //     type:'bar'
          //   })
          //   console.log(this.alertRakingDataList)
          // }


          _this17.shoplist = res.body.merchant_list; // console.log(this.shoplist)
          // return;

          var map = new AMap.Map("container", {
            zoom: 4,
            mapStyle: "amap://styles/blue"
          });
          var vm = _this17;
          AMapUI.loadUI(["overlay/SimpleMarker"], function (SimpleMarker) {
            var _loop = function _loop(_i3) {
              var shop = vm.shoplist[_i3];
              var marker = new SimpleMarker({
                showPositionPoint: true,
                iconStyle: "blue",
                position: [shop.lng, shop.lat]
              }); // 添加标记到地图

              marker.setMap(map); // 创建自定义样式的InfoWindow内容

              var infoContent = "\n  <div style=\"\n    background: rgba(28,134,202,0.9);\n    color: white;\n    padding: 8px;\n    border-radius: 4px;\n    border: 1px solid rgb(28,134,202);\n    box-shadow: 0 2px 6px rgba(0,0,0,0.3);\n  \">\n\n   <p>\u4EE3\u7406\u5546\u540D\u79F0: ".concat(shop.shop_name, "</p>\n     <p>\u4F4D\u7F6E: ").concat(shop.address, "</p>\n  </div>\n"); // 创建InfoWindow

              var infoWindow = new AMap.InfoWindow({
                content: infoContent,
                // 使用自定义样式的内容
                offset: new AMap.Pixel(0, -40),
                isCustom: true,
                closeWhenClickMap: true
              }); // 添加点击事件

              marker.on("click", function () {
                console.log("mapmapmap", shop);
                infoWindow.open(map, marker.getPosition());
              });
            };

            for (var _i3 = 0; _i3 < vm.shoplist.length; _i3++) {
              _loop(_i3);
            }
          });
          AMap.plugin(["AMap.ToolBar"], function () {
            map.addControl(new AMap.ToolBar({
              map: map
            }));
          });
          AMap.plugin(["AMap.ToolBar"], function () {
            map.addControl(new AMap.ToolBar({
              map: map
            }));
          });
        }
      });
    },
    getHomeData1: function getHomeData1(month_time, data_type) {
      var _this18 = this;

      ///this.spinShowLeft=true
      this.spinShowLeft = false;

      if (data_type === 1) {
        this.alertRakingDataList.splice(0);
        this.alertRakingLegend.splice(0);
        this.alertRakingXAxis.splice(0);
      } else if (data_type === 2) {
        this.alertDataList.splice(0);
      } else {
        this.alertDataList.splice(0);
        this.alertRakingXAxis.splice(0);
        this.alertRakingDataList.splice(0);
        this.alertRakingLegend.splice(0);
      }

      this.alertTimeList.splice(0);
      get_index_data({
        month_time: month_time,
        data_type: data_type
      }).then(function (res) {
        _this18.spinShowLeft = false;

        if (res.result === 0) {
          console.log("asdf");

          if (res.body.device_total) {
            _this18.device_total = res.body.device_total;
          }

          if (res.body.alarm_wait_handle_num) {
            _this18.alarm_wait_handle_num = res.body.alarm_wait_handle_num;
          }

          if (res.body.alarm_list) {
            // this.device_alarm_recent = res.body.alarm_list.list || []
            _this18.device_alarm_recent = [{}, {}];
          } //console.log("bbb",this.device_alarm_recent)

        }
      });
    },
    getHomeData2: function getHomeData2(month_time, data_type) {
      var _this19 = this;

      ///this.spinShowRight=true
      this.spinShowRight = false;

      if (data_type === 1) {
        this.alertRakingDataList.splice(0);
        this.alertRakingLegend.splice(0);
        this.alertRakingXAxis.splice(0);
      } else if (data_type === 2) {
        this.alertDataList.splice(0);
      } else {
        this.alertDataList.splice(0);
        this.alertRakingXAxis.splice(0);
        this.alertRakingDataList.splice(0);
        this.alertRakingLegend.splice(0);
      }

      this.alertTimeList.splice(0);
      get_index_data({
        month_time: month_time,
        data_type: data_type
      }).then(function (res) {
        _this19.spinShowRight = false;

        if (res.result === 0) {
          if (res.body.device_total) {
            _this19.device_total = res.body.device_total;
          }

          if (res.body.alarm_wait_handle_num) {
            _this19.alarm_wait_handle_num = res.body.alarm_wait_handle_num;
          }

          if (res.body.device_alarm_recent) {
            _this19.device_alarm_recent = res.body.device_alarm_recent || [];
          }

          console.log("bbb", res.body.merchant_list);

          if (res.body.merchant_list) {
            _this19.shoplist = res.body.merchant_list || [];
            console.log("aaaa", _this19.shoplist);

            if (_this19.shoplist.length > 0) {//this.$set(this,'currMerchan',{...this.shoplist[0],show:true,offset:new this.BMap.Size(0,-22)})
              //   console.log(this.currMerchan)
              // this.$set(this,'center',{lng:this.shoplist[0].lng,lat:this.shoplist[0].lat})
            }
          } //日告警数量分析


          if (res.body.alarm_num_list) {
            for (var i in res.body.alarm_num_list) {
              var list = res.body.alarm_num_list[i];

              if (list.list && list.list.length > 0) {
                var tem = [];

                for (var j in list.list) {
                  tem.push(list.list[j].total);

                  if (j == 0) {
                    _this19.alertTimeList.push(list.list[j].x_axis);
                  }
                }

                _this19.alertDataList.push({
                  name: list.shop_name,
                  data: tem,
                  type: "line"
                });
              }
            }
          } //告警排行


          if (res.body.alarm_phb) {
            var alarm_num_list = [];

            for (var _i4 in res.body.alarm_phb) {
              var listAlerm = res.body.alarm_phb[_i4];

              _this19.alertRakingXAxis.push(listAlerm.shop_name);

              _this19.alertRakingLegend.push(listAlerm.shop_name);

              alarm_num_list.push(listAlerm.count1);
            }

            _this19.alertRakingDataList.push({
              name: "告警排行分析",
              data: alarm_num_list,
              type: "bar"
            });

            console.log(_this19.alertRakingDataList);
          }
        }
      });
    },
    getAlermBox: function getAlermBox() {
      var _this20 = this;

      get_alarm_box({
        type: 1
      }).then(function (res) {
        //传感器列表
        _this20.sensorList.splice(0);

        var hasAlertMess = false;

        if (res.result === 0) {
          if (res.body) {
            var arr = [];
            var sensor_list = res.body || [];
            _this20.sensor_count = sensor_list.length;

            for (var i in sensor_list) {
              var list = sensor_list[i];
              console.log(list.facade_pic_url);

              if (list.sensor_data) {
                //alarm2，,fail, 红色；alarm1， 黄色； 其它，绿色
                if (list.sensor_data.alarm2 > 0 || list.sensor_data.alarm1 > 0) {
                  hasAlertMess = true;
                }

                if (list.sensor_data.alarm2 > 0 || list.sensor_data.fail > 0) {
                  list.classWrapperStyle = "classWrapperRed";
                } else if (list.sensor_data.alarm1 > 0) {
                  list.classWrapperStyle = "classWrapperYellow";
                } else {
                  list.classWrapperStyle = "classWrapperGreen";
                }
              }

              _this20.sensorList.push(list);
            } //设置播放状态


            if (hasAlertMess) {
              _this20.$store.commit("setPlayerState", true);
            } else {
              _this20.$store.commit("setPlayerState", false);
            }

            console.log(_this20.sensorList);
          }
        }
      });
    },
    jumpto: function jumpto(index) {
      if (index == 0) {
        var routeData = this.$router.push({
          path: "/jingxiaoshang"
        });
        window.open(routeData.href, "_self");
      } else if (index == 1) {
        var _routeData3 = this.$router.push({
          path: "/deviceman/devicedistribution"
        });

        window.open(_routeData3.href, "_self");
      } else {
        var _routeData4 = this.$router.push({
          path: "/deviceman/devicedistribution",
          query: {
            status: 2
          }
        });

        window.open(_routeData4.href, "_self");
      } // console.log('我的id',this.$store.state);

    },
    lookdetails: function lookdetails(row, value) {
      console.log('我的大屏数据', row, value);

      if (value == "left") {
        if (row.model_code == "GBMSMT") {
          var routeData = this.$router.push({
            path: "/deviceman/detailsNew",
            query: {
              did: row.did,
              tabs: '0'
            }
          });
          window.open(routeData.href, "_self");
        } else {
          if (row.device_type == 1) {
            var _routeData5 = this.$router.push({
              path: "/deviceman/details",
              query: {
                did: row.did,
                tabname: "设备信息"
              }
            });

            window.open(_routeData5.href, "_self");
          } else if (row.device_type == 2) {
            var _routeData6 = this.$router.push({
              path: "/deviceman/detailsdy",
              query: {
                did: row.did,
                tabname: "设备信息"
              }
            });

            window.open(_routeData6.href, "_self");
          } else if (row.device_type == 3) {
            var _routeData7 = this.$router.push({
              path: "/deviceman/detailscc",
              query: {
                did: row.did,
                tabname: "设备信息"
              }
            });

            window.open(_routeData7.href, "_self");
          }
        }
      } else {
        if (row.model_code == "GBMSMT") {
          var _routeData8 = this.$router.push({
            path: "/deviceman/detailsNew",
            query: {
              did: row.did,
              tabs: '3'
            }
          });

          window.open(_routeData8.href, "_self");
        } else {
          if (row.device_type == 1) {
            var _routeData9 = this.$router.push({
              path: "/deviceman/details",
              query: {
                did: row.did,
                tabname: "告警数据"
              }
            });

            window.open(_routeData9.href, "_self");
          } else if (row.device_type == 2) {
            var _routeData10 = this.$router.push({
              path: "/deviceman/detailsdy",
              query: {
                did: row.did,
                tabname: "告警数据"
              }
            });

            window.open(_routeData10.href, "_self");
          } else if (row.device_type == 3) {
            var _routeData11 = this.$router.push({
              path: "/deviceman/detailscc",
              query: {
                did: row.did,
                tabname: "告警数据"
              }
            });

            window.open(_routeData11.href, "_self");
          }
        }
      }

      console.log("我的列表数据", row); //    const routeData = this.$router.push({ path: '/deviceman/detailsdy', query: { did: row.did } })
      // window.open(routeData.href, '_self')
    }
  },
  mounted: function mounted() {
    var _this21 = this;

    // this.getNodeDeviceAll()
    // this.getNodeUserActive(7)
    // this.getNodeUserAll()//未处理的告警
    // this.getNodeDeviceOnline()
    this.timeout = setInterval(this.getCurrTime, 1000);
    this.getHomeData();
    this.$nextTick(function () {
      _this21.pHeight = _this21.$refs.tableContent.clientHeight - 50;
      _this21.tableHeight = _this21.$refs.tableContent.clientHeight - 50;
      console.log("aa", _this21.tableHeight);

      _this21.onResize();

      window.addEventListener("resize", _this21.onResize); // this.setInt=setInterval(()=>{
      //   this.getAlermBox()
      // },2000)
    }); // 顶部数据

    this.getTopData();
    this.getOnlineInfo(); // 获取大屏左下方近7日激活(仅顶级账号可见)

    console.log("this.userInfoStore.is_dingji", this.userInfoStore.is_dingji);
    localStorage.setItem("is_dingji", this.userInfoStore.is_dingji);

    if (this.userInfoStore.is_dingji === 1) {
      this.getAdminAction();
    }

    this.getAlertRight(); // this.getAlermBox()
    // this.getMerchantList()

    var month = getMonthToCurrent(0);
    this.currDate = month;
    this.currDate1 = month;
    var shuaxin = localStorage.getItem("shuaxin");
    var refreshTime = 60;

    if (shuaxin) {
      refreshTime = JSON.parse(shuaxin);
    }

    this.setIner = setInterval(function () {
      _this21.getHomeData();

      _this21.getTopData();

      _this21.getOnlineInfo(); // 获取大屏左下方近7日激活(仅顶级账号可见)


      console.log("this.userInfoStore.is_dingji", _this21.userInfoStore.is_dingji);

      if (_this21.userInfoStore.is_dingji === 1) {
        _this21.getAdminAction();
      }

      _this21.getAlertRight();
    }, refreshTime * 1000);
  },
  created: function created() {
    var _this22 = this;

    get_website_data().then(function (res) {
      console.log("this.$i18n.locale ", _this22.$i18n.locale, res);

      if (_this22.$i18n.locale == "zh-CN") {
        _this22.titleName = res.body.web_name[0].zh;
      }

      if (_this22.$i18n.locale == "en-US") {
        _this22.titleName = res.body.web_name[0].en;
      }
    });
    var gett = localStorage.getItem("routesMenu");

    if (gett) {
      var r = getMenuByRouterRole(JSON.parse(gett), menuList);

      for (var i = 0; i < routersArr.length; i++) {
        if (routersArr[i].name === "_home") {
          var _routersArr$i$childre;

          (_routersArr$i$childre = routersArr[i].children).push.apply(_routersArr$i$childre, _toConsumableArray(r));

          break;
        }
      }

      console.log("菜单", routersArr);
      router.addRoutes(routersArr.concat([{
        path: "*",
        redirect: "/404"
      }]));
    }

    this.routerData = JSON.parse(localStorage.getItem("routesMenu"));
  },
  activated: function activated() {
    debugger;
  },
  deactivated: function deactivated() {
    debugger;

    if (this.setIner) {
      clearInterval(this.setIner);
    }

    if (this.setInt) {
      clearInterval(this.setInt);
    }

    if (this.timeout) {
      clearInterval(this.timeout);
    }

    window.removeEventListener("resize", this.onResize);
    this.$Notice.destroy();
  },
  destroyed: function destroyed() {
    debugger;

    if (this.setIner) {
      clearInterval(this.setIner);
    }

    if (this.setInt) {
      clearInterval(this.setInt);
    }

    if (this.timeout) {
      clearInterval(this.timeout);
    }

    window.removeEventListener("resize", this.onResize);
    this.$Notice.destroy();
  }
};